import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../Loader";
import OwlCarousel from "react-owl-carousel2";
import { fixImagePaths } from "../../components/util";

const Project = () => {
  const { page } = useSelector((state) => state.data);
  const [portfolioContent, setPortfolioContent] = useState("");

  useEffect(() => {
    if (page?.data?.portfolio?.htmlContent) {
      // Step 1: Decode HTML
      const parser = new DOMParser();
      const decodedDoc = parser.parseFromString(
        page.data.portfolio.htmlContent,
        "text/html"
      );
      const decodedHTML = decodedDoc.documentElement.textContent;

      // Step 2: Fix image paths
      const fixedHtml = fixImagePaths(decodedHTML);

      // Step 3: Set to state
      setPortfolioContent(fixedHtml);
    }
  }, [page]);

  if (!page || !page.data) {
    return <Loader />;
  }

  return (
    <div
      id="rs-portfolio"
      className="rs-project style1 pt-110 md-pt-80 mb--150"
    >
      <div className="container">
        {portfolioContent ? (
          <div dangerouslySetInnerHTML={{ __html: portfolioContent }} />
        ) : (
          <Loader />
        )}
        <OwlCarousel />
      </div>
    </div>
  );
};

export default Project;
